export default (str) => {
  const pattern = new RegExp('[\\w.]+@\\w+\\.\\w+', 'gmi');
  return !!pattern.test(str);
};
